import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { change } from 'redux-form';
import { connect } from 'react-redux';

class FileInputComponent extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    id: PropTypes.string.isRequired,
    input: PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.any
    }).isRequired,
    meta: PropTypes.shape({
      form: PropTypes.string
    }).isRequired,
    accept: PropTypes.string,
    required: PropTypes.bool,
    className: PropTypes.string,
    onFileChange: PropTypes.func
  };

  static defaultProps = {
    accept: '',
    required: false,
    className: '',
    onFileChange: null
  };

  constructor(props) {
    super(props);
    this.state = {
      file: undefined
    };
  }

  onChange(e) {
    const { onFileChange } = this.props;
    const file = e.target.files[0];
    this.setState({ file });
    this.changeFileValue(file);

    if (onFileChange) {
      onFileChange(e, file);
    }
  }

  changeFileValue(value) {
    const {
      dispatch,
      input: { name },
      meta: { form }
    } = this.props;
    dispatch(change(
      form,
      name,
      value
    ));
  }

  removeFile() {
    this.setState({ file: undefined });
    const { id } = this.props;
    const inputEl = document.getElementById(id);
    if (inputEl) {
      inputEl.value = '';
    }
    this.changeFileValue(null);
  }

  render() {
    const {
      id,
      input: {
        name
      },
      accept,
      required,
      className
    } = this.props;
    const { file } = this.state;
    return (
      <div className="file-input-custom input-group">
        <span className="input-group-addon">Choose file</span>
        <input
          type="text"
          className={ className }
          placeholder={ file ? file.name : 'No file selected' }
        />
        { file && <span
          title="Remove file"
          className="btn btn-sm input-group-btn"
        >
          <span
            role="button"
            onClick={ () => this.removeFile() }
            tabIndex={ 0 }
            className="icon icon-cross"
            aria-hidden="true"
          />
        </span> }
        <input
          id={ id }
          name={ name }
          type="file"
          onChange={ e => this.onChange(e) }
          accept={ accept }
          required={ required }
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({ dispatch });

// eslint-disable-next-line import/prefer-default-export
export const FileInput = connect(
  null,
  mapDispatchToProps
)(FileInputComponent);
